import PanelLayout from '@amzn/awsui-components-core/panel-layout';
import { Alert } from '@amzn/awsui-components-core';
import React, { useEffect } from 'react';
import { useAskQuick } from './AskQuickContext';
import { ASK_QUICK_CHAT_URL } from 'src/constants/AppConstants';
import { useQuickSightAuth } from 'src/hooks/useQuickSightAuth';
import { logger } from 'src/logger';

import './AskQuickPanel.scss';

interface AskQuickPanelProps {
  header: React.ReactNode;
  children: React.ReactNode;
}

export const AskQuickPanel: React.FC<AskQuickPanelProps> = ({ header, children }) => {
  const { isOpen, panelSize, onPanelResize, minPanelSize, maxPanelSize, activeAgentUrl } = useAskQuick();
  const authState = useQuickSightAuth(isOpen);

  useEffect(() => {
    logger.info(`QuickSuite: panel ${isOpen ? 'opened' : 'closed'}`);
  }, [isOpen]);

  return (
    <div className="ask-quick-panel-wrapper">
      {header}
      <div className="ask-quick-panel-wrapper__body">
        <PanelLayout
          display={isOpen ? 'all' : 'main-only'}
          panelPosition="side-end"
          resizable={true}
          panelSize={panelSize}
          minPanelSize={minPanelSize}
          maxPanelSize={maxPanelSize}
          onPanelResize={({ detail }) => onPanelResize(detail.panelSize)}
          i18nStrings={{
            resizeHandleAriaLabel: 'Resize QuickSuite panel',
            resizeHandleTooltipText: 'Drag to resize'
          }}
          mainContent={<div className="ask-quick-panel-wrapper__main">{children}</div>}
          panelContent={
            isOpen ? (
              <div className="ask-quick-panel">
                {authState === 'needs-auth' && (
                  <div className="ask-quick-panel__banner">
                    <Alert type="info">Please sign in to your AmazonBI account below to continue.</Alert>
                  </div>
                )}
                {authState === 'failed' && (
                  <div className="ask-quick-panel__banner">
                    <Alert type="error">Authentication timed out. Please close and reopen the panel to try again.</Alert>
                  </div>
                )}
                <iframe
                  className="ask-quick-panel__iframe"
                  src={activeAgentUrl ? activeAgentUrl : ASK_QUICK_CHAT_URL.default}
                  title="Ask Quick Chat Agent"
                  allow="clipboard-read https://us-east-1.quicksight.aws.amazon.com; clipboard-write https://us-east-1.quicksight.aws.amazon.com"
                />
              </div>
            ) : null
          }
        />
      </div>
    </div>
  );
};
